import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import Pagination from '../pagination/Pagination.jsx'
import Button from '../Button.jsx'
import Flash from '../flash/Flash.jsx'
import { ListMatches, DeleteMatch } from '../../repo/MatchesRepo.js'
import { GetTournament } from '../../repo/TournamentsRepo.js'

export default function AdminMatchesList({tournamentId, ...props}) {
  const [searchParams] = useSearchParams();
  const page = searchParams.get('page') || "1";

  const [tournament, setTournament] = useState()
  const [matches, setMatches] = useState([])
  const [pagination, setPagination] = useState(null)
  const [currentPage, setCurrentPage] = useState(page)
  const [showFlashMessage, setShowFlashMessage] = useState(false)

  const handlePaginationClick = async (newMatchesPage) => {
    setCurrentPage(newMatchesPage)

    window.history.replaceState(null, "Bolão: Admin Matches", "?page=" + newMatchesPage)
  }

  const handleDeleteMatchClick = (tournamentId, matchId) => {
    if (window.confirm("Delete?")) {
      deleteMatch(tournamentId, matchId).then(deleted => {
        if (deleted) {
          loadMatches(1)
          window.history.replaceState(null, "Bolão: Admin Matches", '')
          setShowFlashMessage(true)
        }
      })
    }
  }

  const handleEditMatchClick = (tournamentId, matchId) => {
    window.location.href = "/cocofantoelefanto/tournaments/" + tournamentId + "/matches/" + matchId + "/edit"
  }

  useEffect(() => {
    loadMatches(currentPage)
  }, [currentPage])

  useEffect(() => {
    if (tournament) {
      props.setTournamentFullNameOnLoad(tournament.name + " " + tournament.edition)
    }
  }, [tournament, props])

  async function loadMatches(page) {
    const tournament = await GetTournament(tournamentId)
    setTournament(tournament)

    const resData = await ListMatches(tournamentId, page)
    setMatches(resData.data)
    setPagination(resData.pagination)
  }

  return (
    <>
      {showFlashMessage && (
        <Flash message="Match was successfully deleted" type="success" timer={5000}/>
      )}
      <table className="w-full text-sm text-left rtl:text-right text-gray-500 mt-4">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
          <tr>
            <th scope="col" className="px-6 py-3">Jogo</th>
            <th scope="col" className="px-6 py-3">Data-Hora UTC</th>
            <th scope="col" className="px-6 py-3">API/ID</th>
            <th scope="col" className="px-6 py-3">Actions</th>
          </tr>
        </thead>
        <tbody>
        {matches.map((match) => {
          return (
            <tr key={match.id} className="odd:bg-white even:bg-gray-50 border-b border-gray-200">
              <td className="px-4 py-2">
                <Link className="hover:no-underline underline" to={`/cocofantoelefanto/tournaments/${tournamentId}/matches/${match.id}`}>{match.team_a_name} x {match.team_b_name}</Link>
                {match.is_demo &&
                  <span className="bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded ml-2">Demo</span>
                }
              </td>
              <td className="px-4 py-2">
                {match.starts_at}
              </td>
              <td className="px-4 py-2">
                {match.third_party_label ? match.third_party_label : "-"}/{match.third_party_id ? match.third_party_id : "-"}
              </td>
              <td className="px-4 py-2 space-x-2">
                <Button styleName="yellow" onClick={() => handleEditMatchClick(tournamentId, match.id)}>Edit</Button>
                <Button styleName="red" onClick={() => handleDeleteMatchClick(tournamentId, match.id)}>Delete</Button>
              </td>
            </tr>
          )
        })}
        </tbody>
      </table>

      <Pagination pagination={pagination} onPaginationClick={handlePaginationClick} />
    </>
  )
}

async function deleteMatch(tournamentId, matchId) {
  return DeleteMatch(tournamentId, matchId)
}
